import { BaseEntity } from "@app/models/rest/base-entity";
import { SorCode } from "@app/models/rest/sor-code";
import { VisitType } from "@app/models/rest/visit-type";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("sorCodeOverrides")
export class SorCodeOverride extends BaseEntity {
  contracts: string;
  workTypes: string;
  sorCode: SorCode;
  visitType: VisitType;
}
